import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "login" };
const _hoisted_2 = { class: "flex h-screen" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "i flex w-1/2 items-center justify-around bg-gradient-to-tr from-blue-900 to-blue-800" }, [
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("h1", { class: "font-sans text-4xl font-bold text-white" }, " p_bus 写真管理 "),
        /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-white" }, "お問い合わせ"),
        /*#__PURE__*/ _createElementVNode("button", {
            type: "submit",
            class: "mb-2 mt-4 block w-28 rounded-2xl bg-white py-2 font-bold text-indigo-800"
        }, " 使い方 ")
    ])
], -1);
const _hoisted_4 = { class: "flex w-1/2 items-center justify-center bg-white" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h1", { class: "mb-1 text-2xl font-bold text-gray-800" }, "ログイン", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-7 text-sm font-normal text-gray-600" }, " メールアドレスとパスワードを入力してください。 ", -1);
const _hoisted_7 = { class: "mb-4 flex items-center rounded-2xl border-2 px-3 py-2" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 text-gray-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
    })
], -1);
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "flex items-center rounded-2xl border-2 px-3 py-2" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "currentColor"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
        "clip-rule": "evenodd"
    })
], -1);
const _hoisted_12 = { key: 1 };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "ml-2 cursor-pointer text-sm hover:text-blue-500" }, "パスワードを忘れた方はこちら", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
                (!_ctx.isConfirm)
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 0,
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.handleSubmit()), ["prevent"])),
                        class: "bg-white"
                    }, [
                        _hoisted_5,
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.email) = $event)),
                                maxlength: "128",
                                class: "border-none pl-2 outline-none",
                                type: "email",
                                placeholder: "メールアドレス",
                                onFocus: _cache[1] || (_cache[1] = ($event) => (_ctx.focus()))
                            }, null, 544), [
                                [_vModelText, _ctx.email]
                            ])
                        ]),
                        (_ctx.errorEmail != '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.errorEmail), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.password) = $event)),
                                maxlength: "128",
                                class: "border-none pl-2 outline-none",
                                type: "password",
                                placeholder: "パスワード"
                            }, null, 512), [
                                [_vModelText, _ctx.password]
                            ])
                        ]),
                        (_ctx.errorPassword != '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.errorPassword), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            type: "submit",
                            disabled: _ctx.isLoading || _ctx.hasError,
                            class: _normalizeClass([{ 'cursor-not-allowed opacity-60': _ctx.hasError }, "mb-2 mt-4 block w-full rounded-2xl bg-blue-800 py-2 font-semibold text-white"])
                        }, " ログイン ", 10, _hoisted_13),
                        _hoisted_14
                    ], 32))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
